try {

var h5Tag = document.getElementsByTagName("h5");
var attArr = [];
cleanTag();

var prodSingDes = document.getElementsByClassName("product-single__description rte");

var prodInnerHTML = prodSingDes[0].innerHTML;
var prodInnerText = prodSingDes[0].innerText;
var strg = "";
var startArr =[];
var closeArr =[];

if(prodInnerHTML.includes("<h5>Description</h5>") != true) {
    var desc = "<h5>Description</h5> ";
    strg = desc.concat(prodInnerHTML);
}

var strArr = strg.split("<h5>");
var arrStr = strArr.join("<h5>");
var arrArr = [];
var tabArr = [];
var tabTitle = [];
var gridSt = "font-size: medium; text-align: center; display: grid; grid-template-columns: repeat( auto-fit, minmax(100px, 1fr) );";
var tabStyle = "text-decoration: none; color: #696969; background-color: #ccc; border-width: 1px 1px 1px 1px; border-style: solid; border-color: #778899; outline: none;";
var actStyle = "text-decoration: none; background-color: #fff; border-width: 1px 1px 0px 1px; border-style: solid; border-color: #778899; outline: none; color: #222;";
var grdConStyle = "padding: 2%; border-style: solid; border-color: #778899; border-width: 0px 1px 1px 1px; background-color: #fff; border-radius: 0 5px 10px 10px;  max-height: 340px; overflow: auto;";

for(var i=0; i<strArr.length; i++) {
    var arr = strArr[i].split("</h5>");
    if(arr[0] == "" || arr[0] == null) {
    } else {
        arrArr.push(arr);
    }
}

for(var i=0; i<arrArr.length; i++) {
    tabArr.push(arrArr[i][0]);
}

for(var i=0; i<tabArr.length; i++) {
    if(tabArr[i] == "" || tabArr[i] == null) {
    } else {
        if(tabTitle == "") {
            tabTitle.push(`<button class="grdCon active" style="${actStyle}">${tabArr[i]}</button>`)
        } else {
            tabTitle.push(`<button class="grdCon" style="${tabStyle}">${tabArr[i]}</button>`)
        }
    }
}

change(tabTitle.join(""), gridSt, grdConStyle);

roundTab();

updateTabsLocation();

$(window).on('resize', function()
{
  updateTabsLocation();
});

makeTabsVisible();

function changeStyle(grdConList) {
    for(var i=0; i<grdConList.length; i++) {
        if(grdConList[i].classList.contains("active")) {
            document.getElementsByClassName("active").style = actStyle;
        } else {
            document.getElementsByClassName("grdVal").style = tabStyle;
        }
    }
}

function change(val, style, grdStyle) {
    var valArr = arrArr[0][1];
    document.getElementsByClassName("product-single__description rte")[0].innerHTML =
        `<div id="tabGrid" style="${style}">${val}</div><div class="grdVal" style="${grdStyle}">${valArr}</div>`;
        var grdConList = document.getElementsByClassName("grdCon");
        for(var i=0; i<grdConList.length; i++) {
            grdConList[i].addEventListener("click", function() {
                var current = document.getElementsByClassName("active");
                if (current.length > 0) {
                    current[0].className = current[0].className.replace(" active", "");
                }
                this.className += " active";
                for(var i=0; i<grdConList.length; i++) {
                    if(grdConList[i].classList.contains("active")) {
                        document.getElementsByClassName("grdVal")[0].innerHTML = arrArr[i][1];
                        grdConList[i].style = actStyle;
                    } else {
                        grdConList[i].style = tabStyle;
                    }
                }
                roundTab();
            });
        }
};

function cleanTag() {
  for(var i=0; i<h5Tag.length; i++) {
    var hSt = String(h5Tag[i].attributes.length);
    var hth = h5Tag[i].innerHTML;
    if (hth.includes("&nbsp;") == true) {
      var a = hth.toString().replace("&nbsp;", " ");
      h5Tag[i].innerHTML = a;
    } else if (hth.includes("<br>") == true) {
      var a = hth.toString().replace("<br>", " ");
      h5Tag[i].innerHTML = a;
    }
    if(hSt >= 1) {
      var x = h5Tag[i];
      var y = x.getAttributeNames(x);
      var z = h5Tag[i].attributes;
      // for (var e=0; e<z.length; e++) {
      //   attArr.push(z[e]);
      // }
      for(var j=0; j<y.length; j++) {
        document.getElementsByTagName("h5")[i].removeAttribute(y[j]);
      }
    }
  }
};

function roundTab() {
  var prodTabs = document.getElementsByClassName('grdCon');
  var lastTab = (prodTabs.length - 1);

  prodTabs[0].style.borderRadius = "10px 0 0 0";
  prodTabs[lastTab].style.borderRadius = "0 10px 0 0";
  prodTabs[lastTab].style.width = "90%";
}

function updateTabsLocation()
{
  if ($(window).width() > 625)
  {
    if (!$('#productPageContainer .prodDesc > .product-single__description').length)
      $('#productPageContainer .prodDesc').append($('.product-single__description'));
  }
  else
  {
    if (!$('#productPageContainerMobile .prodDesc > .product-single__description').length)
      $('#productPageContainerMobile .prodDesc').append($('.product-single__description'));
  }
}

function makeTabsVisible()
{
  $('.product-single__description').removeClass('invisible');
}

} catch (error) {
  
  console.log(error);
}